module.exports = __webpack_public_path__ + "iphone.png?e09c5aefef0ff5c48d9de6742cae8418";